<template>
  <div v-if="!isLoading">
    <voucher-banner
      :banner-id="promotionCode"
      :banner-json-url="bannerJsonUrl"
    />
    <div
      class="voucher-wrap"
      :style="isStandAloneMode ? 'margin-top:50px' : ''"
    >
      <div class="voucher-inner-wrap">
        <section>
          <h2 class="page-text">방송/영화/해외 시리즈 무제한!</h2>
          <ul class="voucher-list">
            <li
              v-for="(voucher, index) in voucherList"
              :key="'wavve_voucher_' + index"
            >
              <div class="inner-wrap">
                <div class="label-area">
                  <h3>
                    <span>{{ getValue(voucher, 'product_name') }}</span>
                    <!--                <span class="icon">이용중</span>-->
                    <span
                      v-if="isStandardVoucher(voucher)"
                      class="icon icon-supplant"
                      >추천</span
                    >
                  </h3>

                  <div class="price-area">
                    <span
                      v-if="getValue(voucher, 'displayamount') !== ''"
                      class="before-price"
                      >&#65510;{{
                        setNumberCommas(getValue(voucher, 'displayamount'))
                      }}</span
                    >
                    <button
                      type="button"
                      :class="
                        getValue(voucher, 'product_name') ===
                        getValue(selectedVoucher, 'product_name')
                          ? 'btn selected'
                          : 'btn'
                      "
                      @click="purchase(voucher)"
                    >
                      &#65510;{{ setNumberCommas(getValue(voucher, 'amount')) }}
                    </button>
                  </div>
                </div>
                <voucher-table-list
                  :support-device="getValue(voucher, 'mobile_support_device')"
                  :quality="getValue(voucher, 'quality')"
                  :concurrency="getValue(voucher, 'concurrency')"
                />
              </div>
            </li>
          </ul>
          <div class="common-benefit">
            <h4>이용권 공통 혜택</h4>
            <ul class="common-benefit-list">
              <li>
                <span
                  >VOD 30만편 이상&lpar;방송/해외시리즈/키즈/애니메이션 등&rpar;
                  제공</span
                >
              </li>
              <li>
                <span>LIVE 100개 이상 채널 시청</span>
              </li>
              <li>
                <span
                  >영화 6천편 무제한 시청&lpar;영화플러스 개별구매
                  별도&rpar;</span
                >
              </li>
              <li>
                <span
                  >다운로드 무제한 &lpar;PC 30회 제한&rpar; & QVOD / 타임머신
                  이용
                </span>
              </li>
            </ul>
          </div>
        </section>
        <!--        <div class="voucher-group-title">{{groupName}}</div>-->
        <!--        <div v-for="(category, index1) in dataList" :key="index1" class="voucher-list-wrap">-->
        <!--          <voucher-group v-for="(group, index2) in category.productgroups"-->
        <!--                         :key="(''+index1+index2)"-->
        <!--                         :group-info="group"-->
        <!--                         :category-name="category.passgroup_name"-->
        <!--                         :product-type="category.passgroup_type"-->
        <!--                         :group-index="(''+index1+index2)"-->
        <!--                         :category-index="index1"-->
        <!--                         :current-group-index="currentGroupIndex"-->
        <!--                         :current-value-in-group="currentValueInGroup"-->
        <!--                         :current-category-index="currentCategoryIndex"-->
        <!--                         :set-number-commas="setNumberCommas"-->
        <!--          />-->
        <!--        </div>-->
      </div>
      <BottomGuideNormal />
    </div>
  </div>
</template>

<script>
  import { VoucherService } from '@/common/api/api.service'
  import { EventBus } from '@/components/lnb/voucher/VoucherEventBus'
  import BottomGuideNormal from '@/components/lnb/voucher/BottomGuideNormal.vue'
  import VoucherBanner from '@/components/lnb/voucher/VoucherBanner'
  import utils from '@/common/util/utils'
  import { get } from 'lodash'
  import { voucherPurchase } from '@/common/util/common'
  import {
    SPECIAL_PROMOTION_HOSTNAME,
    PROMOTION_MAPPER,
  } from '@/common/constant'
  import { PATH_NAME_HOME } from '@/common/router.const'
  import { DEVICE_TYPE_ANDROID } from '@/common/devicetype.const'
  import VoucherTableList from '@/components/lnb/voucher/VoucherTableList'
  import braze from '@/common/util/braze'
  import {
    getPurchaseProperties,
    normalizePurchaseParams,
  } from '@/common/util/braze.util'

  export default {
    components: {
      BottomGuideNormal,
      VoucherBanner,
      VoucherTableList,
    },
    data() {
      return {
        voucherList: [],
        selectedVoucher: {},
        dataList: [],
        purchaseGroupName: '',
        purchaseScreenName: '',
        purchaseQualityName: '',
        purchasePrice: 0,
        eventClass: 'event-open',
        eventToggle: false,
        toggleClass: 'option-open',
        userLine: '0',
        concurrencyCount: 1,
        currentCategoryIndex: 0,
        currentGroupIndex: '00',
        currentValueInGroup: 'group_00_0',
        checkedProductType: '',
        description: '',
        promotionCode: '',
        promotionInfo: {},
        bannerJsonUrl: null,
        device: utils.cookies.getDevice(),
        isLoading: true,
        productId: '',
        currentVoucherInfo: {},
      }
    },
    computed: {
      groupName() {
        return get(this.dataList, ['0', 'passgroup_name'], '')
      },
      isStandAloneMode() {
        const promotionCode = get(this.$route, 'query.promotioncode', '')
        const standaloneTypeCode = ['forholder']
        return standaloneTypeCode.indexOf(promotionCode) > -1
      },
    },
    created() {
      this.promotionCode = get(this.$route, ['query', 'promotioncode'], '')
      if (!this.promotionCodeValidator(this.promotionCode)) {
        this.$router.replace({ name: PATH_NAME_HOME, query: {} })
      }
      if (this.promotionCode === '') {
        // this.alertAndRedirect()
      } else {
        this.setData()
      }
      EventBus.$on('changeSelectedIndex', this.onChangeSelectedIndex)
      EventBus.$on('productListInfo', this.onProductListInfo)
    },
    mounted() {
      window.addEventListener('message', this.postMessage)
    },
    beforeDestroy() {
      EventBus.$off('changeSelectedIndex', this.onChangeSelectedIndex)
      EventBus.$off('productListInfo', this.onProductListInfo)
      window.removeEventListener('message', this.postMessage)
    },
    methods: {
      getValue(voucher, key) {
        return get(voucher, ['concurrency', '0', key], '')
      },
      isStandardVoucher(voucher) {
        return (
          this.getValue(voucher, 'product_name').toLowerCase() === 'standard'
        )
      },
      clickEvent() {
        this.eventToggle = !this.eventToggle
        this.eventClass = this.eventToggle ? 'event-close' : 'event-open'
      },
      setNumberCommas(data) {
        if (!data) return 0
        return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      getCurrentVoucher() {
        const group =
          this.dataList[this.currentCategoryIndex].productgroups[
            this.currentGroupIndex.charAt(1)
          ]
        return group.products[this.currentValueInGroup.split('_').pop()]
      },
      setVoucherPrice() {
        const voucher = this.getCurrentVoucher()
        this.purchasePrice = get(voucher, ['concurrency', '0', 'amount'], '')
      },
      onChangeSelectedIndex(
        groupIndex,
        currentValueInGroup,
        currentCategoryIndex,
      ) {
        this.currentGroupIndex = groupIndex
        this.currentValueInGroup = currentValueInGroup
        this.currentCategoryIndex = currentCategoryIndex
        this.setVoucherPrice()
      },
      onProductListInfo(data) {
        this.currentVoucherInfo = get(data, 'listInfo.concurrency.0', {})
        this.productId = get(this.currentVoucherInfo, 'productid', '')
      },
      purchase(voucher) {
        this.selectedVoucher = voucher
        const isExternal =
          get(
            this.currentVoucherInfo,
            'is_product_external',
            'n',
          ).toUpperCase() === 'Y'
        const linkTarget = get(
          this.currentVoucherInfo,
          'external_link_target',
          '',
        )
        if (isExternal) {
          if (this.device === DEVICE_TYPE_ANDROID) {
            location.href = get(
              this.currentVoucherInfo,
              'external_link_android',
              '',
            )
          } else {
            window.open(
              get(this.currentVoucherInfo, 'external_link_mobile', ''),
              linkTarget,
            )
          }
        } else {
          const callbackParams = {
            next:
              location.hostname === SPECIAL_PROMOTION_HOSTNAME
                ? 'replace'
                : 'setData',
            ...normalizePurchaseParams({
              ...get(voucher, 'concurrency.0', {}),
            }),
          }
          this.checkPromotionValid()
          voucherPurchase({
            deviceType: this.device,
            productId: get(voucher, 'concurrency.0.productid', ''),
            contentType: '',
            contentId: '',
            promotionCode: this.promotionCode,
            callbackAction: 'purchaseComplete',
            callbackParams,
            pgName: utils.getPgName(),
            canceledCallbackAction: 'Cancel',
          })
        }
      },
      alertAndRedirect() {
        alert(
          '종료되었거나 이용할 수 없는 프로모션 입니다. \n일반 이용권 페이지로 이동합니다',
        )
        this.$router.push('/voucher/index')
      },
      getPromotionData() {
        return VoucherService.getPromotionInfo()
      },
      checkPromotionValid() {
        this.getPromotionData().then(({ data }) => {
          if (
            get(
              data,
              `promotionList.${this.promotionCode}.passlistJsonUrl`,
              '',
            ) === ''
          ) {
            // this.alertAndRedirect()
          }
        })
      },
      setData() {
        this.checkPromotionValid()
        this.isLoading = true
        const timeStamp = new Date().getTime()
        this.getPromotionData().then(({ data }) => {
          this.promotionInfo = data
          const path = `promotionList.${this.promotionCode}.`
          const voucherJsonUrl = get(
            this.promotionInfo,
            path + 'passlistJsonUrl',
            '',
          )
          const bannerType = get(this.promotionInfo, path + 'bannerType', '')
          this.bannerJsonUrl =
            bannerType === 'static'
              ? get(this.promotionInfo, path + 'bannerJsonUrl_mobile', '')
              : ''
          VoucherService.getVoucherPromotion({
            url: voucherJsonUrl + '?timeStamp=' + timeStamp,
          }).then(({ data }) => {
            this.voucherList = get(
              data,
              ['0', 'productgroups', '0', 'products'],
              [],
            )
            this.isLoading = false
          })
        })
      },
      promotionCodeValidator(promotionCode) {
        if (promotionCode === PROMOTION_MAPPER[SPECIAL_PROMOTION_HOSTNAME]) {
          return location.hostname === SPECIAL_PROMOTION_HOSTNAME
        } else {
          return true
        }
      },
      async postMessage(e) {
        if (e.origin === location.origin) {
          const { eventMessage, params = {} } = e.data
          if (eventMessage === 'purchaseComplete') {
            if (params.result === 'y') {
              braze.purchase(getPurchaseProperties(params))
            }
            const credential = utils.cookies.getCredential()
            const isMultiLine =
              Number(utils.cookies.userInfo('profilecount')) !== 1
            await utils.login.credentialAutoLogin(
              credential,
              isMultiLine,
              false,
            )
            switch (params.next) {
              case 'replace':
                this.$router.replace('/thanks')
                break
              case 'reload':
                window.location.reload(true)
                break
              case 'setData':
                this.setData()
                break
              default:
                break
            }
          }
        }
      },
    },
  }
</script>
